import React from 'react';
import { Link } from 'react-router-dom';
import './navbarDrivers.css';
import './navbarParking.css';

const NavbarParking = () => (
  <div className="navbar-block-container right-side">
    <ul className="head nav navbar-nav">
      <li className="dropdown">
        <Link to="/" className="city-link dropdown-toggle" data-toggle="dropdown">
          <span className="glyphicon glyphicon-chevron-down" />
          Management Team
        </Link>
        <ul className="drower dropdown-menu dropdown-spacing">
          <li>John Gabriel</li>
          <li>Darren Martinelli</li>
          <li>Ferenc Toth</li>
        </ul>
      </li>
      <li className="dropdown">
        <Link to="/" className="city-link dropdown-toggle" data-toggle="dropdown">
          <span className="glyphicon glyphicon-chevron-down" />
          Maintenance Team
        </Link>
        <ul className="drower dropdown-menu dropdown-spacing">
          <li>George Marji</li>
          <li>Peter Akinsola</li>
          <li>Rahim Quaderi</li>
          <li>Anthony Pitiselis​</li>
        </ul>
      </li>
    </ul>
  </div>
);
export default NavbarParking;

// for when login is setup again
/*
  <li className="link">
    <Link to="/impark">Bookings</Link>
  </li>
  <li
    className="text-center link"
    onClick={() => logoutParking(history)}>
    <Link to="/parkingaccess">Logout</Link>
  </li>
*/



// WEBPACK FOOTER //
// ./src/components/Layout/NavbarParking.js